import { ConfigurationFormData } from '../../types';

export enum QuestionId {
  ALLOCATION_TEAM = 'ALLOCATION_TEAM',
  ALLOCATION_PURPOSE = 'ALLOCATION_PURPOSE',
  DPD_BUCKET = 'DPD_BUCKET',
  CASE_TEAM = 'CASE_TEAM',
  CASE_EXPIRY_DAYS = 'CASE_EXPIRY_DAYS',
  ALLOCATION_DATES = 'ALLOCATION_DATES',
  DPD_EXCLUSIONS = 'DPD_EXCLUSIONS',
  EMI_OVERDUE_GT = 'EMI_OVERDUE_GT',
  EMI_AMOUNT_GT = 'EMI_AMOUNT_GT',
  LM_NON_ENACH_AMOUNT_GT = 'LM_NON_ENACH_AMOUNT_GT',
  TM_NON_ENACH_AMOUNT_GT = 'TM_NON_ENACH_AMOUNT_GT',
  POS_GT = 'POS_GT',
  TM_COSMOS_NC_FEEDBACK = 'TM_COSMOS_NC_FEEDBACK',
  TM_COSMOS_NC_FEEDBACK_DAYS = 'TM_COSMOS_NC_FEEDBACK_DAYS',
  TM_LONGHORN_NC_FEEDBACK = 'TM_LONGHORN_NC_FEEDBACK',
  TM_LONGHORN_NC_FEEDBACK_DAYS = 'TM_LONGHORN_NC_FEEDBACK_DAYS',
  LM_COSMOS_NC_FEEDBACK = 'LM_COSMOS_NC_FEEDBACK',
  LM_LONGHORN_NC_FEEDBACK = 'LM_LONGHORN_NC_FEEDBACK'
}

export const questionIdToFieldName: { [key in QuestionId]: keyof ConfigurationFormData } = {
  [QuestionId.ALLOCATION_TEAM]: 'allocationTeam',
  [QuestionId.ALLOCATION_PURPOSE]: 'allocationPurpose',
  [QuestionId.DPD_BUCKET]: 'caseDpdBucket',
  [QuestionId.CASE_TEAM]: 'caseTeam',
  [QuestionId.CASE_EXPIRY_DAYS]: 'caseExpiry',
  [QuestionId.ALLOCATION_DATES]: 'allocationDates',
  [QuestionId.DPD_EXCLUSIONS]: 'dpdExclusion',
  [QuestionId.EMI_OVERDUE_GT]: 'emiOverdue',
  [QuestionId.EMI_AMOUNT_GT]: 'emiAmount',
  [QuestionId.LM_NON_ENACH_AMOUNT_GT]: 'lastMonthCollection',
  [QuestionId.TM_NON_ENACH_AMOUNT_GT]: 'currentMonthCollection',
  [QuestionId.POS_GT]: 'posAmount',
  [QuestionId.TM_COSMOS_NC_FEEDBACK]: 'currentMonthCosmosNcFeedback',
  [QuestionId.TM_COSMOS_NC_FEEDBACK_DAYS]: 'currentMonthCosmosNcFeedbackDays',
  [QuestionId.TM_LONGHORN_NC_FEEDBACK]: 'currentMonthLonghornNcFeedback',
  [QuestionId.TM_LONGHORN_NC_FEEDBACK_DAYS]: 'currentMonthLonghornNcFeedbackDays',
  [QuestionId.LM_COSMOS_NC_FEEDBACK]: 'lastMonthCosmosNcFeedback',
  [QuestionId.LM_LONGHORN_NC_FEEDBACK]: 'lastMonthLonghornNcFeedback'
};

export const TEXT_INPUT_FIELD_IDS = [
  QuestionId.CASE_EXPIRY_DAYS,
  QuestionId.EMI_OVERDUE_GT,
  QuestionId.EMI_AMOUNT_GT,
  QuestionId.LM_NON_ENACH_AMOUNT_GT,
  QuestionId.TM_NON_ENACH_AMOUNT_GT,
  QuestionId.POS_GT,
  QuestionId.TM_COSMOS_NC_FEEDBACK_DAYS,
  QuestionId.TM_LONGHORN_NC_FEEDBACK_DAYS
];

export const MULTI_DROPDOWN_FIELD_IDS = [
  QuestionId.TM_COSMOS_NC_FEEDBACK,
  QuestionId.TM_LONGHORN_NC_FEEDBACK,
  QuestionId.LM_COSMOS_NC_FEEDBACK,
  QuestionId.LM_LONGHORN_NC_FEEDBACK,
  QuestionId.DPD_BUCKET
];

export const CUSTOM_PLACEHOLDER_IDS = [
  QuestionId.EMI_OVERDUE_GT,
  QuestionId.EMI_AMOUNT_GT,
  QuestionId.LM_NON_ENACH_AMOUNT_GT,
  QuestionId.TM_NON_ENACH_AMOUNT_GT,
  QuestionId.POS_GT,
  QuestionId.TM_COSMOS_NC_FEEDBACK,
  QuestionId.TM_COSMOS_NC_FEEDBACK_DAYS,
  QuestionId.TM_LONGHORN_NC_FEEDBACK,
  QuestionId.TM_LONGHORN_NC_FEEDBACK_DAYS,
  QuestionId.LM_COSMOS_NC_FEEDBACK,
  QuestionId.LM_LONGHORN_NC_FEEDBACK
];
